import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { Formik } from 'formik';

import { SaveButton } from 'src/libs/ui-kit/buttons/SaveButton';

import 'src/components/Modals/modals.style.css';

import { EditForm } from './EditForm';
import { useProfileWidgetStore } from './StoreProvider';

export const EditModal = observer(() => {
  const store = useProfileWidgetStore();

  return (
    <Formik
      initialValues={store.formData!}
      onSubmit={store.onSubmitEditForm}
      validateOnChange
      validateOnBlur
      validateOnMount
      enableReinitialize>
      <Modal className="modal-slide" show={store.isEditOpen} onHide={store.closeEditForm}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Редактировать</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditForm />
        </Modal.Body>
        <Modal.Footer>
          <SaveButton>Подтвердить</SaveButton>
          <Button variant="light" onClick={store.closeEditForm}>
            Отменить
          </Button>
        </Modal.Footer>
      </Modal>
    </Formik>
  );
});
